import listReducer from '../common/list-reducer';
import listItemReducer from '../common/list-item-reducer';
import postOperatorReducer from './reducer.postOperatorResult';
import identityReducer from '../common/identity-reducer';
import {getOperatorsAction, getOperatorAction, changePasswordAction} from "./actions";

const operatorsReducer = listReducer.bind(getOperatorsAction.getListReduceThisObj());
const operatorInfoReducer = listItemReducer.bind(getOperatorAction.getListReduceThisObj());
const changePassReducer = identityReducer.bind(changePasswordAction.getIdentityReducerThisObj());

export default ({
    operators: operatorsReducer,
    operatorsInfo: operatorInfoReducer,
    postOperatorInfoResult: postOperatorReducer,
    changePassResult: changePassReducer
});